import React from 'react'
import { connect } from "react-redux";
import { addMessage } from "../Actions/messages";

const AuthRequired = (ComposedComponent) => {
    class Authenticate extends React.Component {
        componentWillMount() {
            if (this.props.auth.login !== true || (sessionStorage.getItem("token") === null || sessionStorage.getItem("token") === "")) {
                this.props.history.push("/login");
                this.props.addMessage("Login is Required to Access Private Routes!", "danger");
            }
        }
        render() {
            return (
                <ComposedComponent history={this.props.history} match={this.props.match} />
            );
        }
    }
    return connect(state => ({ auth: state.auth }), { addMessage })(Authenticate);
};

export default AuthRequired;


// WEBPACK FOOTER //
// ./src/Components/AuthRequired.jsx